var map = {
	"./checkout.json": [
		33645,
		3645
	],
	"./collection.json": [
		34050,
		4050
	],
	"./common.json": [
		36326,
		6326
	],
	"./detention.json": [
		53363,
		3363
	],
	"./devotion.json": [
		9457,
		6591
	],
	"./gamepage.json": [
		14546,
		4546
	],
	"./homepage.json": [
		92775,
		2775
	],
	"./login.json": [
		10941,
		941
	],
	"./myaccount.json": [
		2062,
		2062
	],
	"./projectpage.json": [
		36149,
		6149
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 81538;
module.exports = webpackAsyncContext;